import EmployeesSearchBar from "./EmployeesSearchBar";

export default EmployeesSearchBar;
